module.exports = __webpack_public_path__ + "static/img/SmileAnimation_cherry.e4eb2ab.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_cherry.gif
// module id = lxI3
// module chunks = 0